import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=83dd96d8&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=83dd96d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dd96d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83dd96d8')) {
      api.createRecord('83dd96d8', component.options)
    } else {
      api.reload('83dd96d8', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=83dd96d8&scoped=true", function () {
      api.rerender('83dd96d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinners/Spinner.vue"
export default component.exports